export default __webpack_public_path__ + "media/images/images/gallery/17-cff7aad3a2c36fb1f5381ce063b466ba.jpg";